export const getBreadcrumb = state => state.breadcrumb;
export const getRestoringState = state => state.restoringState;
export const getReloadCrmConnections = state => state.reloadCrmConnections;
export const getLoginCarouselContent = state => state.loginCarouselContent;
